

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class StatusSelect extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;

  public isOpen = 1;

  localValue: any = null
  selectdItemLabel: any = '';
  dropdownActive = false;

  pipelines: any[] = [];
  statuses: any[] = [];

  itemsForDisplay: any[] = [];

  searchText: string = '';

  public created() {
    //
  }

  public mounted() {
    this.loadData();
  }

  public loadData() {
    const QNAME_STATUSES = `SELECT_COMBOBOX_LIST_STATUSES`;
    const QNAME_PIPELINES = `SELECT_COMBOBOX_LIST_PIPELINES`;

    this.$db([
      this.$q(QNAME_STATUSES)
        .select()
        .fileds({
            id: `statuses.id`,
            name: `statuses.name`,
            pipeline_id: "statuses.pipeline_id",
            code: "statuses.code",
            position: "statuses.position",
            color: "statuses.color",
            final: "statuses.final",
        })
        .order((_: any) => {
            return [
                _.asc([`statuses.position`]),
            ];
        })
        .from('statuses')
        .limit(1000),
      this.$q(QNAME_PIPELINES)
        .select()
        .fileds({
            id: `pipelines.id`,
            name: `pipelines.name`,
            code: "pipelines.code",
            position: "pipelines.position",
        })
        .order((_: any) => {
            return [
                _.asc([`pipelines.position`]),
            ];
        })
        .from('pipelines')
        .limit(1000),
    ]).then(((result: ServerResult) => {
      const pipelines = result.getOperation(QNAME_PIPELINES).getContent().documents;
      const statuses = result.getOperation(QNAME_STATUSES).getContent().documents;

      const pipesMap = pipelines.reduce((acc: any, cur: any) => {
        const id = cur.id;
        const data = { ...cur, statuses: []};
        return { ...acc, [id]: data };
      }, {});

      for(const status of statuses) {
        pipesMap[status.pipeline_id].statuses.push(
          status
        );
      }

      this.pipelines = Object.values(pipesMap);
      this.statuses = statuses;

      this.onValueChange(this.value);
    }));
  }

  @Watch('value')
  onValueChange(newVal: any) {
    console.log(newVal);
    this.localValue = newVal;

    if (this.localValue) {
      const selectdItem = this.statuses.find((item) => item.id == this.localValue);
      console.log('selectdItem', selectdItem, this.localValue);

      if (selectdItem) {
        this.selectdItemLabel = selectdItem.name;
      } else {
        this.selectdItemLabel = ''
      }
    }
  }

  updateValue(value: any) {
    this.onValueChange(value);
    this.$emit('input', value);
    (this.$refs.dropdown as any).toggle()
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
  }

}
